const LoadingScreen = ({ message = 'Processing...', subMessage = 'Please wait while we verify your information' }) => (
  <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4 fixed top-0 left-0 w-full z-50">
    <div className="card text-center">
      <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-primary mx-auto mb-6"></div>
      <h2 className="text-2xl font-bold text-gray-800 mb-2">{message}</h2>
      <p className="text-gray-600">{subMessage}</p>
    </div>
  </div>
);

export default LoadingScreen;
